import {
	HOME_ROUTE,
	INFO_HOME_ROUTE,
	TASK_HOME_ROUTE,
	ADMIN_HOME_ROUTE,
	SUPER_ADMIN_DASHBOARD_ROUTE,
} from "features/home/home-routes";

// Import icons
import DashboardIcon from "@material-ui/icons/DashboardOutlined";
import EqualizerIcon from "@material-ui/icons/Equalizer";
import ViewListIcon from "@material-ui/icons/ViewList";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";

// Info section icons
import PeopleIcon from "@material-ui/icons/People";
import RoomIcon from "@material-ui/icons/Room";
import PersonIcon from "@material-ui/icons/Person";
import WarningIcon from "@material-ui/icons/Warning";
import LocalPharmacyIcon from "@material-ui/icons/LocalPharmacy";
import SchoolIcon from "@material-ui/icons/School";
import ChromeReaderModeIcon from "@material-ui/icons/ChromeReaderMode";
import ListIcon from "@material-ui/icons/List";
import NoteAddIcon from "@material-ui/icons/NoteAdd";
import AssignmentIcon from "@material-ui/icons/Assignment";
import NotificationsIcon from "@material-ui/icons/Notifications";

// Tasks section icons
import AccessAlarmIcon from "@material-ui/icons/AccessAlarm";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";
import EventNoteIcon from "@material-ui/icons/EventNote";
import PhotoCameraIcon from "@material-ui/icons/PhotoCamera";
import FlashOnIcon from "@material-ui/icons/FlashOn";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import ForumIcon from "@material-ui/icons/Forum";
import SpeedIcon from "@material-ui/icons/Speed";

// Admin section icons
import AccountIcon from "@material-ui/icons/AccountCircle";
import PeopleOutlineIcon from "@material-ui/icons/PeopleOutline";
import PaymentIcon from "@material-ui/icons/Payment";
import DraftsIcon from "@material-ui/icons/Drafts";
import DescriptionIcon from "@material-ui/icons/Description";
import AnnouncementIcon from "@material-ui/icons/Announcement";
import LockIcon from "@material-ui/icons/Lock";

// Import route constants
import { CUSTOMERS_PATH } from "features/customers";
import { STAFF_PATH } from "features/staff";
import { SITES_PATH } from "features/sites";
import { JOBS_PATH, ADD_JOB_PATH } from "features/jobs";
import { DOCUMENT_PACK_ROUTE } from "features/document-pack/routes";
import { ACCOUNT_REPORTS_ROUTE, ACCOUNT_NOTIFICATIONS_ROUTE } from "features/account";
import { LIST_TIMESHEETS_ROUTE, ADD_TIMESHEET_ROUTE } from "features/timesheet/timesheet-routes";
import { LIST_LEAVES_ROUTE } from "features/leave/leave-routes";
import { MY_TASKS_ROUTE } from "features/schedule";
import { EQUIPMENT_USAGE_LIST_ROUTE } from "features/equipment/actions/types";
import { getTasksNavTitle } from "utils/roles";
import * as fromHealthAndSafety from "features/health-and-safety";
import * as fromHealthSafetyForm from "features/health-safety-forms";
import * as fromAccount from "features/account";
const createNavigationConfig = (customerLabel = "Customer", siteLabel = "Site", role = "") => [
	{
		title: "Navigation",
		pages: [
			{
				title: "Home",
				href: HOME_ROUTE,
				children: [
					{
						title: "+ Timesheet",
						href: ADD_TIMESHEET_ROUTE,
						icon: AccessAlarmIcon,
					},
					{
						title: "+ Photo / Note",
						href: ADD_JOB_PATH,
						icon: PhotoCameraIcon,
					},
					{
						title: getTasksNavTitle(role),
						href: MY_TASKS_ROUTE,
						icon: AssignmentTurnedInIcon,
					},
				],
			},
			{
				title: "Info",
				href: INFO_HOME_ROUTE,
				children: [
					{
						title: `${customerLabel}s`,
						href: CUSTOMERS_PATH,
						icon: PeopleIcon,
					},
					{
						title: `${siteLabel}s`,
						href: SITES_PATH,
						icon: RoomIcon,
					},
					{
						title: "Staff",
						href: STAFF_PATH,
						icon: PersonIcon,
					},
					{
						title: "Equipment",
						href: fromAccount.ACCOUNT_MANAGE_EQUIPMENT,
						icon: AssignmentIcon,
					},
					{
						title: "Hazard Library",
						href: fromHealthAndSafety.INFO_HAZARDS_ROUTE,
						icon: WarningIcon,
					},
					{
						title: "Hazardous Substance Library",
						href: fromHealthAndSafety.INFO_HAZARDOUS_SUBSTANCES_ROUTE,
						icon: LocalPharmacyIcon,
					},
					{
						title: "Staff Training Topics",
						href: fromHealthAndSafety.INFO_STAFF_TRAINING_TOPIC_ROUTE,
						icon: SchoolIcon,
					},
					{
						title: "Job Safety Analysis (JSA)",
						href: fromHealthAndSafety.INFO_JOB_SAFETY_ANALYSIS_ROUTE,
						icon: ChromeReaderModeIcon,
					},
					{
						title: "Site Safety Plans (Checklist)",
						href: fromHealthAndSafety.INFO_SAFETY_PLAN_CHECKLISTS_ROUTE,
						icon: ListIcon,
					},
					{
						title: "Documents",
						href: DOCUMENT_PACK_ROUTE,
						icon: NoteAddIcon,
					},
				],
			},
			{
				title: "Activity",
				href: TASK_HOME_ROUTE,
				children: [
					{
						title: "Timesheets",
						href: LIST_TIMESHEETS_ROUTE,
						icon: AccessAlarmIcon,
					},
					{
						title: "Leave",
						href: LIST_LEAVES_ROUTE,
						icon: EventNoteIcon,
					},
					{
						title: getTasksNavTitle(role),
						href: MY_TASKS_ROUTE,
						icon: AssignmentTurnedInIcon,
					},
					{
						title: "Photos / Notes",
						href: JOBS_PATH,
						icon: PhotoCameraIcon,
					},
					{
						title: "Equipment Usage",
						href: EQUIPMENT_USAGE_LIST_ROUTE,
						icon: SpeedIcon,
					},
					{
						title: "Incidents",
						href: fromHealthAndSafety.TASK_INCIDENTS_ROUTE,
						icon: FlashOnIcon,
					},
					{
						title: "Induction Meetings",
						href: fromHealthAndSafety.TASK_INDUCTION_MINUTES_ROUTE,
						icon: PersonAddIcon,
					},
					{
						title: "Safety Minutes",
						href: fromHealthAndSafety.TASK_SAFETY_MINUTES_ROUTE,
						icon: ForumIcon,
					},
					{
						title: "Staff Trainings",
						href: fromHealthAndSafety.TASK_STAFF_TRAINING_ROUTE,
						icon: PeopleIcon,
					},
					{
						title: "Site Inspection Checklists",
						href: fromHealthAndSafety.INFO_SITE_INSPECTION_CHECKLISTS_ROUTE,
						icon: AssignmentIcon,
					},
				],
			},
			{
				title: "Admin",
				href: ADMIN_HOME_ROUTE,
				children: [
					{
						title: "Super Admin Dashboard",
						href: SUPER_ADMIN_DASHBOARD_ROUTE,
						icon: EqualizerIcon,
						restrictedRoles: [
							"Staff User",
							"Staff Non User",
							"Account Administrator",
							"Consultant",
						],
					},
					{
						title: "Profile",
						href: fromAccount.ACCOUNT_PROFILE_ROUTE,
						icon: AccountIcon,
					},
					{
					title: "Accounts",
						href: fromAccount.ACCOUNT_ORGANISATIONS_ROUTE,
						icon: PeopleOutlineIcon,
					},
					{
						title: "Subscription",
						href: fromAccount.ACCOUNT_SUBSCRIPTION_ROUTE,
						icon: PaymentIcon,
						restrictedRoles: ["Staff User"], // Staff users can't manage subscriptions
					},
					{
						title: "Invite Consultant",
						href: fromAccount.ACCOUNT_INVITE_ROUTE,
						icon: DraftsIcon,
						restrictedRoles: ["Staff User"], // Staff users can't invite organisations
					},
					{
						title: "Reports",
						href: fromAccount.ACCOUNT_REPORTS_ROUTE,
						icon: DescriptionIcon,
					},
					{
						title: "Settings",
						title: "Settings",
						href: fromAccount.ACCOUNT_NOTIFICATIONS_ROUTE,
						icon: AnnouncementIcon,
					},
					{
						title: "Change Password",
						href: fromAccount.ACCOUNT_PASSWORD_ROUTE,
						icon: LockIcon,
					},
					{
						title: "Manage Staff Types",
						href: fromAccount.ACCOUNT_MANGE_STAFF_TYPE,
						icon: PeopleIcon,
						restrictedRoles: ["Staff User"], // Staff users can't manage staff types
					},
					{
						title: "Manage Work Types",
						href: fromAccount.ACCOUNT_MANAGE_TASK_TYPE,
						icon: AssignmentIcon,
						restrictedRoles: ["Staff User"], // Staff users can't manage work types
					},
					{
						title: "Manage Leave Types",
						href: fromAccount.ACCOUNT_MANAGE_LEAVE_TYPE,
						icon: AssignmentIcon,
						restrictedRoles: ["Staff User"], // Staff users can't manage leave types
					},
				],
			},
		],
	},
];

export default createNavigationConfig;